import _ from 'lodash'
import type {DeepReadonly} from './types'

export const omitUndefined = <T extends Record<string, any>>(obj: T): Partial<T> => _.omitBy<T>(obj, _.isUndefined)

export const deepFreeze = <T>(obj: T): DeepReadonly<T> => {
    // eslint-disable-next-line lodash/prefer-lodash-typecheck
    if (typeof obj !== 'object' || obj === null) {
        return obj as DeepReadonly<T>
    }

    const propNames = Reflect.ownKeys(obj) as (keyof T)[]

    for (const name of propNames) {
        const value = obj[name]
        // eslint-disable-next-line lodash/prefer-lodash-typecheck
        if (value && (typeof value === 'object' || typeof value === 'function')) {
            deepFreeze(value)
        }
    }

    return Object.freeze(obj) as DeepReadonly<T>
}
